<template>
  <div id="summary" class="panel active">
    <div v-if="ageGroup" class="panel-content summary pt-xs-4 pt-md-80 mb-xs-4">
      <div class="narrow px-xs-4">
        <h1 v-html="$getString('GLOBAL_SIGNS_OF_A_MOTOR_DELAY')"></h1>
        <div class="bottom-hr bg-sma-turquoise mb-xs-4"></div>
        <h2 class="mb-xs-4" v-html="$getString('SUMMARY_TAKE_THE_NEXT_STEP')"></h2>
        <p class="smaller fg-sma-black-75" v-html="$getTemplatedString('SUMMARY_BASED_ON_YOUR_ANSWERS', { 'child_state': ageGroup.state })"></p>
        <div class="tool-button next" @click="onResults('results-download', 'download')" v-html="$getString('SUMMARY_RESULTS_DOWNLOAD_BUTTON')"></div>
      </div>

      <div class="mt-xs-4 py-xs-4 bg-sma-turquoise-10">
        <div class="narrow px-xs-4">
          <h2 class="font-alternate fg-sma-blue mb-xs-2" v-html="$getString('SUMMARY_RESULTS_HEADING')"></h2>
          <div class="bottom-hr bg-sma-turquoise mb-xs-4"></div>
          <p class="smaller fg-sma-black-50" v-html="$getTemplatedString('SUMMARY_YOU_HAVE_SELECTED', { 'child_state': ageGroup.state })"></p>

          <ul class="summary-options fg-sma-fuchsia">
            <li><div class="icon-download" @click="onResults('results-download', 'summary')" v-html="$getString('SUMMARY_RESULTS_DOWNLOAD')"></div></li>
            <li><div class="icon-print" @click="onResults('results', 'print')" v-html="$getString('SUMMARY_RESULTS_PRINT')"></div></li>
            <li><div class="icon-share" @click="onShare" v-html="$getString('SUMMARY_RESULTS_SHARE')"></div></li>
          </ul>
        </div>
      </div>

      <div class="mt-xs-4 py-xs-4 bg-sma-turquoise-10">
        <div class="narrow px-xs-4">
          <h2 class="font-alternate fg-sma-blue mb-xs-2" v-html="$getString('SUMMARY_YOU_SELECTED')"></h2>
          <div class="bottom-hr bg-sma-turquoise mb-xs-4"></div>
          <ul class="selection-list row">
            <li v-for="(symptom, index) in symptoms" :key="index" class="col-xs-12 col-xl-6 mb-xs-4">
              <div class="symptom-header active pl-xs-3">
                <p v-html="symptom.label"></p>
                <div class="show-info" @click="openSymptomPopup(symptom.index)"></div>
              </div>
            </li>
          </ul>
          
          <h2 class="font-alternate fg-sma-blue mt-xs-4 mb-xs-2" v-html="$getString('SUMMARY_YOUR_RESULTS')"></h2>
          <div class="bottom-hr bg-sma-turquoise mb-xs-4"></div>
          <div class="result-list-container">
            <ul class="results-list">
              <li v-for="(answer, index) in answers" :key="index" v-html="answer"></li>
            </ul>
            <ul class="slider-list">
              <li v-for="(slider, index) in sliders" :key="index" v-html="slider"></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="buttons my-xs-20">
        <div class="tool-button next" @click="onSave" v-html="$getString('GLOBAL_BUTTON_SAVE')"></div>
      </div>
      
      <div id="restart" class="restart-buttons container text-centered mt-xs-4">
        <div class="d-xs-inline-block fg-sma-fuchsia"><span class="icon icon-restart"></span>&nbsp;<span v-html="$getString('GLOBAL_RESTART')"></span><div class="button-overlay" @click="onRestart"></div></div>
        <div class="d-xs-inline-block fg-sma-fuchsia"><span class="icon icon-info"></span>&nbsp;<span v-html="$getString('GLOBAL_FURTHER_INFORMATION')"></span><div class="button-overlay" @click="openFurtherPopup"></div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StageSummary',
  props: {
    stage: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      ageGroup: null,
      symptoms: [],
      symptomStrings: [],
      answers: [],
      sliders: [],
      query: '',

      handlers: [],
    }
  },
  methods: {
    onSave() {
      this.$emit('action', { type: 'save' });
      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_save`,
      } });
      this.$emit('action', { type: 'open-popup', data: {
        type: 'saved',
      }});
    },
    onResults(key, analyticsKey) {
      const url = this.$store.getters.link(key);
      if (url) {
        window.open(url + this.query, '_blank');

        const analyticsValue = this.$store.getters.analytics.summary[analyticsKey];
        this.$emit('action', { type: 'log-analytics', data: {
          "category": 'Internal_link_click',
          "action": '/',
          "label": `{page_label}_${analyticsValue}`,
        } });
      }
    },
    onShare() {
      this.$emit('action', { type: 'open-popup', data: { type: 'share' } });
      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_share_results`,
      } });
    },
    openSymptomPopup(index) {
      const symptom = this.ageGroup.symptoms[index];
      this.$emit('action', { type: 'open-popup', data: {
        type: 'symptom',
        heading: symptom.label,
        items: symptom.popupList,
      }});
    },
    onRestart() {
      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_restart`,
      } });
      this.$emit('action', { type: 'restart' });
    },
    openFurtherPopup() {
      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_further_info`,
      } });
      this.$emit('action', { type: 'open-popup', data: {
        type: 'further',
      }});
    },
    
    getQuery() {
      const now = new Date();
      const symptoms = this.symptomStrings.join(';');
      const answers = this.answers.join(';');
      const sliders = this.sliders.join(';');
      const timestamp = now.toLocaleTimeString() + ' | ' + now.toLocaleDateString();
      const uri = `?selected=${symptoms}&results=${answers}&sliders=${sliders}&timestamp=${timestamp}`;

      return uri.replace(/(&amp;){1}/g, '%26');
    },

    async postData(url = "", data = {}) {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }).then((response) => response.json());
      return response.json();
    },

    getShortUrl(data) {
      const saveUrl = url => this.$emit('action', { type: 'store-results-url', data: {
        query: this.query,
        download: url,
      } });
      
      fetch(`/caregiver-tool-results`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ url: data }),
      })
        .then((response) => response.json())
        .then((json) => saveUrl(json));
    },

    storeResults() {
      this.query = this.getQuery();
      const downloadUrl = this.$store.getters.link('results-download');
      this.getShortUrl(`${downloadUrl}${this.query}`);
    },
    getResults() {
      const symptoms = this.$store.getters.dataKey('symptoms');
      const questions = this.$store.getters.dataKey('questions');
      const sliders = this.$store.getters.dataKey('sliders');

      this.symptoms = [];
      symptoms.forEach(symptomIndex => {
        const symptom = this.ageGroup.symptoms[symptomIndex];
        this.symptoms.push(symptom);
        this.symptomStrings.push(symptom.label);
      });

      this.answers = [];
      questions.forEach(question => {
        question.answers.forEach(answer => {
          if (answer > -1)
            this.answers.push(question.options[answer]);
        });
      });
      if (this.answers.length === 0) {
        this.answers = [ 'No Concern' ];
      }

      this.sliders = [];
      for (let key in sliders) {      
        this.sliders.push(sliders[key].string);
      }

      if (!this.query) {
        this.storeResults();
      }
    },
  },
  mounted() {
    this.ageGroup = this.$store.getters.ageGroup;

    const region = document.body.getAttribute('data-region');
    const storageId = `SIGNSOFSMA_CAREGIVER_TOOL_${region}`;
    const links = window.localStorage.getItem(storageId + '_LINK');
    if (links) {
      this.query = links.query;
    }

    this.getResults();
  },
}
</script>
